// Número oficial do WhatsApp da Contabeleza (+55 11 91155-0367), no formato exigido pelo wa.me (apenas dígitos).
export const WHATSAPP_NUMBER = "5511911550367";

export const DEFAULT_WA_MESSAGE =
    "Olá! Conheci a Contabeleza pelo site e gostaria de entender qual solução é mais adequada para o meu negócio de beleza.";

export const waLink = (message = DEFAULT_WA_MESSAGE, origin = "") => {
    const suffix = `\n\n· origem: site contabeleza.com.br${origin ? ` (${origin})` : ""}`;
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message + suffix)}`;
};

export const ILOVEME_URL = "https://ilove.me/";

export const NAV_LINKS = [
    { to: "/solucoes", label: "Soluções", testId: "nav-link-solutions" },
    { to: "/para-quem", label: "Para Quem", testId: "nav-link-audience" },
    { to: ILOVEME_URL, label: "ilove.me", testId: "nav-link-ecosystem" },
    { to: "/sobre", label: "Sobre Nós", testId: "nav-link-about" },
];

export const SIGNIN_OPTIONS = [
    {
        label: "MEI Contabeleza",
        description: "Área do MEI Contabeleza",
        href: "https://mei.contabeleza.com.br",
        testId: "signin-mei-contabeleza",
    },
    {
        label: "ilove.me",
        description: "Agendamento e gestão no ilove.me",
        href: "https://pro.ilove.me",
        testId: "signin-ilove-me",
    },
];

export const MEGA_MENU = [
    {
        title: "Soluções",
        to: "/solucoes",
        items: [
            { to: "/solucoes#lei-do-salao-parceiro", label: "Lei do Salão Parceiro" },
            { to: "/solucoes#gestao-tributaria", label: "Gestão tributária" },
            { to: "/solucoes#bpo-financeiro", label: "BPO Financeiro" },
            { to: "/solucoes#abertura-e-regularizacao", label: "Abertura e regularização" },
            { to: "/solucoes#pessoas-e-equipe", label: "Pessoas e Equipe" },
            { to: "/solucoes#tecnologia-iloveme", label: "Tecnologia ilove.me" },
        ],
    },
    {
        title: "Para quem",
        to: "/para-quem",
        items: [
            { to: "/para-quem#saloes", label: "Salões e barbearias" },
            { to: "/para-quem#clinicas", label: "Clínicas de estética e SPAs" },
            { to: "/para-quem#profissionais", label: "Profissionais da beleza" },
        ],
    },
    {
        title: "ilove.me",
        to: ILOVEME_URL,
        items: [
            { to: "https://ilove.me/funcionalidades/agendamento-online/", label: "Agenda online" },
            { to: "https://ilove.me/funcionalidades/clientes/", label: "Gestão de clientes e equipe" },
            { to: "https://ilove.me/funcionalidades/comissoes/", label: "Comissões e cotas organizadas" },
            { to: "https://ilove.me/funcionalidades/modulo-fiscal/", label: "Notas fiscais discriminadas" },
            { to: "https://ilove.me/funcionalidades/caixa/", label: "Caixa acompanhado de perto" },
            { to: "https://ilove.me/funcionalidades/estoque/", label: "Estoque e produtos" },
        ],
    },
];
